import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseStudyCategoryCurriculumUnits,
  ApiResponseCurriculumUnit,
  ApiResponseCurriculumUnitAutoSelectProblem,
} from '@/api/responses/curriculumUnits'

export namespace CurriculumUnitsApi {
  /**
   * 単元情報の単体取得:学習進捗状況なし
   *
   * @param curriculumUnitId 単元ID
   * @returns 単元情報
   */
  export async function getCurriculumUnit(curriculumUnitId: number): Promise<ApiResponseCurriculumUnit> {
    return await ApiBase.get(`curriculumUnits/${curriculumUnitId}`)
  }

  /**
   * 通常授業サポート学習単元:単体取得
   *
   * @param curriculumUnitId 単元ID
   * @returns 単元情報
   */
  export async function getGeneral(curriculumUnitId: number): Promise<ApiResponseCurriculumUnit> {
    return await ApiBase.get(`curriculumUnits/general/${curriculumUnitId}`)
  }

  /**
   * 講習会トレーニング単元:単体取得
   *
   * @param curriculumUnitId 単元ID
   * @returns 単元情報
   */
  export async function getSeminar(curriculumUnitId: number): Promise<ApiResponseCurriculumUnit> {
    return await ApiBase.get(`curriculumUnits/seminar/${curriculumUnitId}`)
  }

  /**
   * 通常授業サポート教材用単元一覧取得
   *
   * @param studyCategoryId 教材ID
   * @returns 単元一覧
   */
  export async function getGenerals(studyCategoryId: number): Promise<ApiResponseStudyCategoryCurriculumUnits> {
    const params = {
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get('/curriculumUnits/general', params)
  }

  /**
   * 講習会トレーニング教材用単元一覧取得
   *
   * @param studyCategoryId 教材ID
   * @returns 単元一覧
   */
  export async function getSeminars(studyCategoryId: number): Promise<ApiResponseStudyCategoryCurriculumUnits> {
    const params = {
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get('/curriculumUnits/seminar', params)
  }

  /**
   * 通常授業サポートの問題自動選択
   *
   * @param curriculumUnitId 単元ID
   * @returns 自動選択された問題
   */
  export async function getGeneralSelectProblem(
    curriculumUnitId: number
  ): Promise<ApiResponseCurriculumUnitAutoSelectProblem> {
    return await ApiBase.get(`/curriculumUnits/general/${curriculumUnitId}/selectProblem`)
  }
}
